// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nkJS","clinicsSelect":"styles_clinicsSelect__1b3ip"};